import * as React from 'react';
import { Button, Image } from '@fluentui/react-components';
import { useDispatch, useSelector } from 'react-redux';
import { toggleChat } from '../../store';
import { careerStateSelector } from '../../store/Career';
import { CareerHubModuleReactContext } from '../../context/CareerHubModuleReactContext';
import { useOpenCopilotButtonStyles } from './OpenCopilotButton.styles';

/** Opens copilot chat when clicked. Renders nothing is chat is already open. */
export const OpenCopilotButton: React.FC = () => {
  const styles = useOpenCopilotButtonStyles();
  const { isChatOpen } = useSelector(careerStateSelector);
  const dispatch = useDispatch();
  const { telemetryClient } = React.useContext(CareerHubModuleReactContext);
  const assistantButtonRef = React.useRef<HTMLButtonElement>(null);

  React.useEffect(() => {
    if (!isChatOpen) {
      assistantButtonRef.current?.focus();
    }
  }, [isChatOpen]);
  return isChatOpen ? (
    <></>
  ) : (
    <Button
      className={styles.button}
      ref={assistantButtonRef}
      onClick={() => {
        telemetryClient.logButtonClick('Copilot', 'CopilotOpen', {});
        dispatch(toggleChat());
      }}
      icon={<Image src="/assets/botSparkleWithColor.svg" alt="" />}
    >
      <div className={styles.contentContainer}>
        <span> Chat with role library assistant </span>
      </div>
    </Button>
  );
};
